import React from 'react';
import { Outlet } from 'react-router-dom';

const AccountManagement = () => {
  return (
    <div>
      <Outlet /> 
    </div>
  );
};

export default AccountManagement;
